export default function isPredbeznaInformacia(type: string): boolean {
  return type === 'PI';
}
